module.exports = __webpack_public_path__ + "static/component-boxes-mobile-90269e3ce8a74e6490afc07856c08266.jpg";